<template>
  <div id="page-persona-form">
    <vs-row>
      <vs-col>
        <vs-row>
          <vs-col>
            <vue-element-loading :active="busy"></vue-element-loading>
            <card-page :card-title="cardTitle">
              <div class="m-4" v-if="value.System">
                <h5>This is a system persona, it cannot be edited</h5>
              </div>
              <vue-form-generator
                  class="pt-4"
                  ref="personaForm"
                  :model="model"
                  :options="formOptions"
                  :schema="schema"
              />
            </card-page>
              <vue-form-generator
                  ref="form"
                  :model="model"
                  :options="formOptions"
                  :schema="schemaPrivileges"
              />
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>


<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import CardPage from '../../../components/Views/CardPage';

const selectOptions = {
  showLabels: false,
  hideSelected: false,
  key: 'id',
  trackBy: 'id',
  label: 'name',
};

export default {
  name: 'PersonaForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    cardTitle: {
      type: String,
      required: false,
    },
    overrideSystemPersona: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [FormModelMixin],
  components: {
    CardPage
  },
  data() {
    return {
      model: {
        PersonaName: null,
        Role_FK: null,
        privileges: {}
      },
      checkboxStructure: [
        {
          mainLabel: 'CRM',
          subMenu: [
            {
              label: 'Entities',
              sections: [
                {
                  label: 'Entities',
                  route: 'company',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore', 'Publish'],
                },
                {
                  label: 'Addresses',
                  route: 'company_addresses',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
                {
                  label: 'TOBAs',
                  route: 'company_tobas',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
                {
                  label: 'Contacts',
                  route: 'company_contacts',
                  fields: ['List', 'View'],
                },
                {
                  label: 'Distribution Lists',
                  route: 'company_distribution-list',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
                {
                  label: 'Commercial Products',
                  route: 'company_commercial-products',
                  fields: ['View'],
                },
              ],
            },
            {
              label: 'Entity Commercial Products',
              sections: [
                {
                  label: 'Commercial Products FUW',
                  route: 'company_commercial-products_fuw',
                  fields: ['List'],
                },
                {
                  label: 'Commercial Products IPR Producer',
                  route: 'company_commercial-products_ipr-producer',
                  fields: ['List'],
                },
                {
                  label: 'Commercial Products IPR Coverholder',
                  route: 'company_commercial-products_ipr-coverholder',
                  fields: ['List'],
                },
              ],
            },
            {
              label: 'Contacts',
              sections: [
                {
                  label: 'Contacts',
                  route: 'contact',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore', 'Publish'],
                },
                {
                  label: 'Addresses',
                  route: 'contact_addresses',
                  fields: ['List', 'Edit', 'Create', 'Delete'],
                },
                {
                  label: 'Distribution Lists',
                  route: 'contact_distribution-list',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
            {
              label: 'Applications',
              sections: [
                {
                  label: 'Applications',
                  route: 'application',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
            {
              label: 'Roles',
              sections: [
                {
                  label: 'Roles',
                  route: 'role',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'Content Management',
          subMenu: [
            {
              label: 'Content Management',
              sections: [
                {
                  label: 'Administrators',
                  route: 'content-management_administrators',
                  fields: ['List', 'View', 'Edit', 'Create'],
                },
                {
                  label: 'News Popup',
                  route: 'content-management_news',
                  fields: ['List', 'View', 'Edit', 'Create', 'Publish'],
                },
                {
                  label: 'Nodes',
                  route: 'content-management_nodes',
                  fields: ['List', 'View', 'Edit', 'Create'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'Facility Map',
          subMenu: [
            {
              label: 'Facilities',
              sections: [
                {
                  label: 'Facilities',
                  route: 'facilities',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore', 'Publish'],
                },
              ],
            },
            {
              label: 'Sections',
              sections: [
                {
                  label: 'Sections',
                  route: 'facilities_sections',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Lloyds Risk Codes',
                  route: 'facilities_sections_riskCodes',
                  fields: ['View', 'View', 'Edit', 'Create', 'Delete'],
                },
                {
                  label: 'Products',
                  route: 'facilities_sections_products',
                  fields: ['View', 'View', 'Edit', 'Create', 'Delete'],
                },
                {
                  label: 'Ancestors',
                  route: 'facilities_sections_ancestors',
                  fields: ['View', 'View', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
            {
              label: 'Markets',
              sections: [
                {
                  label: 'Markets',
                  route: 'facilities_markets',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
            {
              label: 'FDOs',
              sections: [
                {
                  label: 'FDOs',
                  route: 'facilities_fdos',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
            {
              label: 'Distribution Lists',
              sections: [
                {
                  label: 'Distribution Lists',
                  route: 'facilities_distribution-lists',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'FUW Clients Map',
          subMenu: [
            {
              label: 'Client Maps',
              sections: [
                {
                  label: 'Client Maps',
                  route: 'client-map',
                  fields: ['List', 'Edit', 'Create'],
                },
              ]
            }
          ]
        },
        {
          mainLabel: 'FUW Products',
          subMenu: [
            {
              label: 'Products',
              sections: [
                {
                  label: 'Products',
                  route: 'products',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
              ],
            },
            {
              label: 'Commercial Products',
              sections: [
                {
                  label: 'Commercial Products',
                  route: 'commercial-products',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
                {
                  label: 'Assigned Producers',
                  route: 'commercial-products_producers',
                  fields: ['View', 'Edit'],
                },
                {
                  label: 'Alternative Commercial Products',
                  route: 'commercial-products_alternative-commercial-products',
                  fields: ['View', 'Edit'],
                },
                {
                  label: 'Extra Info',
                  route: 'commercial-products_extra-info',
                  fields: ['View', 'Edit'],
                },
              ],
            },
            {
              label: 'Mapping-renewals',
              sections: [
                {
                  label: 'Mapping-renewals',
                  route: 'mapping-renewals',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
              ],
            },
            {
              label: 'Product Bundles',
              sections: [
                {
                  label: 'Product Bundles',
                  route: 'product-bundles',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
              ],
            },
            {
              label: 'Claims Notifications',
              sections: [
                {
                  label: 'Commercial Claims',
                  route: 'commercial-claims',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Claims Documents',
                  route: 'claims-dynamic',
                  fields: ['List', 'Edit', 'Create'],
                },
              ],
            },
            {
              label: 'Product Documents',
              sections: [
                {
                  label: 'Wording',
                  route: 'wording',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Standard Clause',
                  route: 'standard-clause',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Front Jacket',
                  route: 'front-jacket',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Rear Jacket',
                  route: 'rear-jacket',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Dynamic Product Documents',
                  route: 'dynamic',
                  fields: ['List', 'Edit', 'Create'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'IPR Products - Producer Products',
          subMenu: [
            {
              label: 'Products',
              sections: [
                {
                  label: 'Products',
                  route: 'producer-products_products-ipr',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
              ],
            },
            {
              label: 'Commercial Products',
              sections: [
                {
                  label: 'Commercial Products',
                  route: 'producer-products_commercial-products-ipr',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
                {
                  label: 'Assigned Producers',
                  route: 'producer-products_commercial-products-ipr_producers',
                  fields: ['View', 'Edit'],
                },
                {
                  label: 'Alternative Commercial Products',
                  route: 'producer-products_commercial-products-ipr_alternative-commercial-products',
                  fields: ['View', 'Edit'],
                },
                {
                  label: 'Extra Info',
                  route: 'producer-products_commercial-products-ipr_extra-info',
                  fields: ['View', 'Edit'],
                },
              ],
            },
            {
              label: 'Product Documents',
              sections: [
                {
                  label: 'Wording',
                  route: 'producer-products_wording-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Standard Clause',
                  route: 'producer-products_standard-clause-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Front Jacket',
                  route: 'producer-products_front-jacket-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Rear Jacket',
                  route: 'producer-products_rear-jacket-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Dynamic Product Documents',
                  route: 'producer-products_dynamic-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'IPR Products - Coverholder Products',
          subMenu: [
            {
              label: 'Products',
              sections: [
                {
                  label: 'Products',
                  route: 'coverholder-products_products-ipr',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
              ],
            },
            {
              label: 'Commercial Products',
              sections: [
                {
                  label: 'Commercial Products',
                  route: 'coverholder-products_commercial-products-ipr',
                  fields: ['List', 'View', 'Edit', 'Create', 'Delete', 'Restore'],
                },
                {
                  label: 'Assigned Producers',
                  route: 'coverholder-products_commercial-products-ipr_producers',
                  fields: ['View', 'Edit'],
                },
                {
                  label: 'Alternative Commercial Products',
                  route: 'coverholder-products_commercial-products-ipr_alternative-commercial-products',
                  fields: ['View', 'Edit'],
                },
                {
                  label: 'Extra Info',
                  route: 'coverholder-products_commercial-products-ipr_extra-info',
                  fields: ['View', 'Edit'],
                },
              ],
            },
            {
              label: 'Product Documents',
              sections: [
                {
                  label: 'Wording',
                  route: 'coverholder-products_wording-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Standard Clause',
                  route: 'coverholder-products_standard-clause-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Front Jacket',
                  route: 'coverholder-products_front-jacket-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Rear Jacket',
                  route: 'coverholder-products_rear-jacket-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
                {
                  label: 'Dynamic Product Documents',
                  route: 'coverholder-products_dynamic-ipr',
                  fields: ['List', 'Edit', 'Create'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'IPR Claims Notifications',
          subMenu: [
            {
              label: 'Claims Notifications',
                sections: [
                  {
                    label: 'Commercial Claims',
                    route: 'commercial-claims-ipr',
                    fields: ['List', 'Edit', 'Create'],
                  },
                  {
                    label: 'Claims Documents',
                    route: 'claims-dynamic-ipr',
                    fields: ['List', 'Edit', 'Create'],
                  },
                ],
            },
          ],
        },
        {
          mainLabel: 'Risk Codes',
          subMenu: [
            {
              label: 'Risk Codes',
              sections: [
                {
                  label: 'Risk Codes',
                  route: 'risk-codes',
                  fields: ['List', 'Edit', 'Create', 'Delete'],
                },
              ],
            },
          ],
        },
        {
          mainLabel: 'Logs',
          subMenu: [
            {
              label: 'Auth0',
              sections: [
                {
                  label: 'Auth0',
                  route: 'log',
                  fields: ['List', 'View'],
                },
              ],
            },
            {
              label: 'Audit',
              sections: [
                {
                  label: 'Audit',
                  route: 'audit',
                  fields: ['List', 'View'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'Reports',
          subMenu: [
            {
              label: 'User Sync',
              sections: [
                {
                  label: 'User Sync',
                  route: 'sync_user',
                  fields: ['List'],
                },
              ]
            },
            {
              label: 'Role Sync',
              sections: [
                {
                  label: 'Role Sync',
                  route: 'sync_role',
                  fields: ['List'],
                },
              ]
            },
          ]
        },
      ],
      schema: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                disabled: !!this.value.System && !this.overrideSystemPersona,
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Name',
                model: 'PersonaName',
                required: true,
                validator: ['string', 'required'],
              },
            ]
          },
          {
            styleClasses: 'w-full',
            fields: [
              {
                disabled: !!this.value.System && !this.overrideSystemPersona,
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Role',
                model: 'Role_FK',
                required: true,
                validator: 'required',
                values: () => this.roles.map((role) => ({id: role.id, name: role.name})),
                selectOptions,
              },
            ]
          },
        ],
      },
      schemaPrivileges: {
        groups: [],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      formReferences: [
        'personaForm',
        'form',
      ],
      roles: [],
      options: [
        {
          endpoint: () => this.$api.orionPersonas.listAvailableRoles(this.$route.params.id),
          optionsFieldName: 'roles',
          nameFieldName: 'RoleName',
          idFieldName: 'Role_FK',
          additionalFields: [
            'applications',
          ],
        },
      ]
    };
  },
  methods: {
    checkboxFields() {
      let fields = {};

      this.checkboxStructure.forEach((structure) => {
        fields = {
          styleClasses: 'vx-card w-full custom-checkboxes-wrapper',
          fields: []
        };

        fields.fields.push({
          type: 'label',
          label: structure.mainLabel,
          styleClasses: 'w-5/12 main-label'
        })
        
        const labels = [
          'List',
          'View',
          'Edit',
          'Create',
          'Delete',
          'Restore',
          'Publish'
        ];
        
        labels.forEach((label) => {
          fields.fields.push({
            type: 'label',
            label: label,
            styleClasses: 'w-1/12 main-label field'
          });
        });

        structure.subMenu.forEach((subMenu) => {
          fields.fields.push({
            type: 'label',
            label: subMenu.label,
            styleClasses: 'w-12/12 sub-label'
          })

          subMenu.sections.forEach((section) => {
            fields.fields.push({
              type: 'label',
              label: section.label,
              styleClasses: 'w-5/12 field-group-label'
            })


            labels.forEach((field) => {
              if (!section.fields.includes(field)) {
                fields.fields.push({
                  type: 'label',
                  label: '',
                  styleClasses: 'w-1/12 field-checkbox',
                });

                return true;
              }

              const modelName = `privileges.${section.route}.${field}`;
              const modelNameBase = `privileges.${section.route}.`;
              let disabled = false;

              if (this.model.privileges[section.route]) {
                if (field === 'List'
                    && (parseInt(this.model.privileges[section.route].View)
                        || parseInt(this.model.privileges[section.route].Edit)
                        || parseInt(this.model.privileges[section.route].Create)
                        || parseInt(this.model.privileges[section.route].Delete)
                        || parseInt(this.model.privileges[section.route].Restore))
                ) {
                  disabled = true;
                }

                if (field === 'View'
                    && (parseInt(this.model.privileges[section.route].Edit)
                        || parseInt(this.model.privileges[section.route].Restore))
                ) {
                  disabled = true;
                }
              }

              if (this.value.System && !this.overrideSystemPersona) {
                disabled = true;
              }

              fields.fields.push({
                disabled: disabled,
                type: 'checkbox',
                label: '',
                styleClasses: 'w-1/12 field',
                model: modelName,
                onChanged: (model, value) => {
                  const formFields = this.$refs.form.$children;
                  model.privileges[section.route][field] = value;

                  if (value && (field === 'Edit' || field === 'Restore')) {
                    model.privileges[section.route].View = 1;
                  }

                  if (value && (field !== 'List')) {
                    model.privileges[section.route].List = 1;
                  }

                  let listDisabled = false;
                  let viewDisabled = false;

                  // Only enable the list checkbox if all other fields are unchecked
                  section.fields.forEach((siblingField) => {
                    if (siblingField !== 'List'
                        && model.privileges[section.route][siblingField]
                    ) {
                      listDisabled = true;
                    }

                    if ((siblingField === 'Restore' || siblingField === 'Edit')
                        && model.privileges[section.route][siblingField]
                    ) {
                      viewDisabled = true;
                    }
                  });

                  formFields.forEach((formField) => {
                    if (formField.field.model === modelNameBase + 'List') {
                      formField.field.disabled = listDisabled;
                    }

                    if (formField.field.model === modelNameBase + 'View') {
                      formField.field.disabled = viewDisabled;
                    }
                  });
                }
              });
            });

            // This is used to force a line break between each section
            // fields.fields.push({
            //   type: 'label',
            //   label: '',
            //   styleClasses: 'w-full'
            // })
          });
        });

        this.schemaPrivileges.groups.push(fields);
      });
    },
  },
  async created() {
    await this.loadOpts();
    await this.checkboxFields();
  }
};
</script>

<style lang="scss">
#page-persona-form {
  .vue-form-generator {
    .custom-checkboxes-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-top: 1rem;
      margin-top: 1rem;
      padding-bottom: 2rem;

      .main-label {
        border-bottom: 1px solid #d5dae075;
        margin-bottom: 0;

        label {
          span {
            margin: 0;
            font-size: 20px;
            color: #2c2c2c;
          }
        }

        &.field {
          border-right: 0;
          border-left: 1px solid #D5DAE0;
          display: flex;
          justify-content: center;
          align-items: flex-end;

          label {
            span {
              font-size: 15px;
            }
          }
        }
      }

      .sub-label {
        margin-bottom: 0;
        padding-block: 15px;
        border-bottom: 1px solid #D5DAE0;

        span {
          font-size: 18px;
          font-weight: bold;
        }
      }

      .field-group-label {
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin: 0;
        border-bottom: 1px solid #D5DAE0;
        padding: 1rem 0 1rem 1rem;

        label {
          span {
            margin: 0;
            font-size: 15px;
          }
        }
      }

      .field-checkbox {
        display: inline-flex;
        flex-direction: row;
        justify-content: center;
        margin: 0;
        border: 1px solid #D5DAE0;
        border-top: none;
        border-right: none;
        padding: 1.5rem 0;

        > div {
          input {
            margin: auto;
          }
        }
      }
    }
  }
}
</style>
